import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import MobileAppLinksContent
  from 'components/dashboard/mobile-app-links/MobileAppLinksContent';

const DashboardAppsPage = () => (
  <LinksPageLayout activeLinksPage="apps">
    <MobileAppLinksContent />
  </LinksPageLayout>
);

export default DashboardAppsPage;
